/* ============================================================
   small talk city - cart drawer

   Intercepts add-to-bag forms, posts to Shopify's cart API, and
   renders the cart into a slide-out drawer so browsing is never
   interrupted. All of it is enhancement: with JS off, or on an
   unexpected error, the forms post normally and land on /cart.
   ============================================================ */
(function () {
  'use strict';

  var SECTION = 'stc-cart-contents';
  var root, panel, body, lastFocus, pendingMessage;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Ask Shopify to render our cart section, so the drawer and the cart
  // page can never disagree about what the bag contains.
  function fetchCart() {
    return fetch('/?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (json) {
        return json[SECTION];
      });
  }

  function setCount(n) {
    var nums = document.querySelectorAll('.stc--header .cart-n');
    for (var i = 0; i < nums.length; i++) nums[i].textContent = n;
    var words = document.querySelectorAll('.stc--header .cart-w');
    for (var j = 0; j < words.length; j++) words[j].textContent = n === 1 ? 'item' : 'items';
  }

  function showMessage(text) {
    var slots = document.querySelectorAll('[data-stc-cart-msg]');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = text || '';
      slots[i].hidden = !text;
    }
  }

  function render(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var fresh = d.querySelector('.stc-cart');
    if (!fresh) return;

    setCount(parseInt(fresh.getAttribute('data-stc-cart-count'), 10) || 0);

    if (body) {
      body.innerHTML = '';
      body.appendChild(document.importNode(fresh, true));
    }

    var pageCart = document.querySelector('.stc--cartpage .stc-cart');
    if (pageCart) {
      pageCart.parentNode.replaceChild(document.importNode(fresh, true), pageCart);
    }

    // Shopify draws the wallet buttons itself; importNode does not run
    // their scripts, so ask Shopify to redraw them.
    if (window.Shopify && window.Shopify.PaymentButton) {
      try {
        window.Shopify.PaymentButton.init();
      } catch (e) {}
    }

    if (pendingMessage) {
      showMessage(pendingMessage);
      pendingMessage = null;
    }
  }

  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    // Force a reflow so the transition still runs. Deliberately not
    // requestAnimationFrame: browsers park rAF in background tabs, which
    // would leave the drawer in the DOM, off-screen, with scroll locked.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (panel) panel.focus();
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      root.hidden = true;
    }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refresh(andOpen) {
    return fetchCart()
      .then(function (html) {
        render(html);
        if (andOpen) open();
      })
      .catch(function () {
        if (andOpen) window.location.href = '/cart';
      });
  }

  function addToCart(form) {
    var data = new FormData(form);
    var button = form.querySelector('[type=submit]');
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'adding';
    }

    function restore() {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw e;
          });
        }
        return r.json();
      })
      .then(function () {
        return refresh(true).then(restore);
      })
      .catch(function (err) {
        restore();
        if (err && err.description) {
          // Already in the bag, or gone. Shopify's own wording is clearer
          // than anything we would invent; show it and open the bag.
          pendingMessage = err.description;
          refresh(true);
        } else {
          form.submit();
        }
      });
  }

  function changeLine(line, quantity) {
    showMessage('');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (r.status === 422) {
          // Nearly everything here is one of one, so "no more available"
          // is a normal answer, not a failure. Say so and stay put.
          return r.json().then(function (e) {
            pendingMessage = e.description || 'That is the last one.';
            return refresh(false);
          });
        }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return refresh(false);
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  ready(function () {
    root = document.getElementById('stc-cart-drawer');
    if (!root || !window.fetch || !window.DOMParser) return;
    panel = root.querySelector('.stc-drawer-panel');
    body = root.querySelector('[data-stc-cart-body]');

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      addToCart(form);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var qty = e.target.closest('[data-stc-qty]');
      if (qty) {
        e.preventDefault();
        changeLine(
          parseInt(qty.getAttribute('data-stc-qty'), 10),
          parseInt(qty.getAttribute('data-stc-to'), 10)
        );
        return;
      }

      if (e.target.closest('[data-stc-cart-close]')) {
        e.preventDefault();
        close();
        return;
      }

      var bagLink = e.target.closest('a[href$="/cart"]');
      if (bagLink && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        refresh(true);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) close();
    });

    if (document.querySelector('.stc--header .cart-n')) refresh(false);
  });
})();
